import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { CustomConsensusService } from "../custom-consensus.service";

declare function OnDefaultSetting(sectionName);

@Component({
  selector: "app-custom-consensus-nodata-modal",
  templateUrl: "./custom-consensus-nodata-modal.component.html",
  styleUrls: ["./custom-consensus-nodata-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CustomConsensusNodataModalComponent implements OnInit {
  isCcNodataModalOpen$;
  relativeDays$;
  constructor(private ccServie: CustomConsensusService) {}

  ngOnInit() {
    this.isCcNodataModalOpen$ = this.ccServie.isCcNodataModalOpen$;
    this.relativeDays$ = this.ccServie.relativeDays$;
  }

  handleEditCC = () => {
    this.ccServie.showCcModal(true);
  };

  handleClearCC = () => {
    //clear all sources
    OnDefaultSetting("Sources");
    this.ccServie.showCcNodataModal(false);
  };
}
